import * as Yup from 'yup';
import {
  IATA_FIELD,
  PASSWORD_FIELD,
  AGENT_NAME_FIELD,
  AGENCY_NAME,
  AGENCY_ADDRESS,
  SELECT_COUNTRY,
  SELECT_STATE,
  AGENCY_PHONE_NUMBER,
  AGENCY_FAX_NUMBER,
  AGENCY_EMAIL_ADDRESS,
  AGENCY_CONTACT_NAME,
  AGENCY_IDENTIFICATION_NUMBER,
  CREATE_AGENCY_PASSWORD,
  AGENCY_CERTIFICATE_UPLOAD,
  W_CERTIFICATE_UPLOAD,
  AGENCY_CITY,
  PIN_CODE,
} from '../pageComponents/TALoginPage/partsName';
import {
  EMAIL_PATTERN,
  TA_PASSWORD_PATTERN,
  NUMBER_PATTERN,
} from './regexUtils.js';

export const getValidationSchema = travelAgentErrorMessage =>
  Yup.object().shape({
    [IATA_FIELD]: Yup.string().required(
      travelAgentErrorMessage.iataRequiredMessage
    ),
    [PASSWORD_FIELD]: Yup.string()
      .required(travelAgentErrorMessage.passwordRequiredMessage)
      .min(3, travelAgentErrorMessage.passwordMinLengthMessage),
    [AGENT_NAME_FIELD]: Yup.string().required(
      travelAgentErrorMessage.agentNameRequiredMessage
    ),
  });

export const validationSchema = travelAgentErrorMessage =>
  Yup.object().shape({
    [AGENCY_NAME]: Yup.string().required(
      travelAgentErrorMessage.agencyNameRequiredMessage
    ),
    [AGENCY_ADDRESS]: Yup.string().required(
      travelAgentErrorMessage.agencyAddressRequiredMessage
    ),
    [SELECT_COUNTRY]: Yup.string().required(
      travelAgentErrorMessage.selectCountryRequiredMessage
    ),
    [SELECT_STATE]: Yup.string().required(
      travelAgentErrorMessage.selectStateRequiredMessage
    ),
    [AGENCY_PHONE_NUMBER]: Yup.string()
      .required(travelAgentErrorMessage.phoneNumberRequiredMessage)
      .matches(
        NUMBER_PATTERN,
        travelAgentErrorMessage.agencyInvalidPhoneNumberErrorMessage
      ),
    [AGENCY_FAX_NUMBER]: Yup.string()
      .required(travelAgentErrorMessage.faxNumberRequiredMessage)
      .matches(
        NUMBER_PATTERN,
        travelAgentErrorMessage.agencyInvalidFaxNumberErrorMessage
      ),
    [AGENCY_EMAIL_ADDRESS]: Yup.string()
      .required(travelAgentErrorMessage.emailAddressRequiredMessage)
      .matches(
        EMAIL_PATTERN,
        travelAgentErrorMessage.agencyInvalidEmailErrorMessage
      ),
    [AGENCY_CONTACT_NAME]: Yup.string().required(
      travelAgentErrorMessage.contactNameRequiredMessage
    ),
    [AGENCY_IDENTIFICATION_NUMBER]: Yup.string().required(
      travelAgentErrorMessage.agencyIdentificationRequiredMessage
    ),
    [CREATE_AGENCY_PASSWORD]: Yup.string()
      .required(travelAgentErrorMessage.passwordCreationRequiredMessage)
      .matches(
        TA_PASSWORD_PATTERN,
        travelAgentErrorMessage.agencyInvalidPasswordErrorMessage
      )
      .max(10, travelAgentErrorMessage.agencyMaxPasswordErrorMessage)
      .min(8, travelAgentErrorMessage.agencyMinPasswordErrorMessage),
    [AGENCY_CERTIFICATE_UPLOAD]: Yup.string().required(
      travelAgentErrorMessage.agencyCertRequiredMessage
    ),
    [W_CERTIFICATE_UPLOAD]: Yup.string().required(
      travelAgentErrorMessage.w9CertRequiredMessage
    ),
    [AGENCY_CITY]: Yup.string().required(
      travelAgentErrorMessage.agencyCityRequiredMessage
    ),
    [PIN_CODE]: Yup.string().required(
      travelAgentErrorMessage.agencyPincodeRequiredMessage
    ),
  });
